export default "__VITE_ASSET__3187cfc5__"